import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    events: {
        'click .basic-auth-edit'   : 'onEditBasicAuth',
        'click .basic-auth-remove' : 'onRemoveBasicAuth',
        'click .http-headers-edit' : 'onEditHttpHeaders'
    },

    dom_handlers: {
        onEditBasicAuth: function(e) {
            e.preventDefault();
            Modals.editProjectBasicAuth(this.model);
        },

        onRemoveBasicAuth: function(e) {
            Modals.deleteProjectBasicAuth(this.model);
        },

        onEditHttpHeaders: function(e) {
            e.preventDefault();
            Modals.editProjectHttpHeaders(this.model);
        }
    },

    initialize: function() {
        this.listenTo(this.model, 'change:basic_auth',  this.render);
        this.listenTo(this.model, 'change:http_header', this.render);
    },

    renderBasicAuth: function() {
        var html = '';

        if (this.model.get('basic_auth')) {
            html +=
            '<div class="flex-between-top">' +
                '<div>' +
                    '<div class="margin-bottom-8">&#8226;&#8226;&#8226;&#8226;&#8226;&#8226; / &#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</div>' +
                    '<button type="button" class="basic-auth-edit text-primary-small"><i class="fa-solid fa-key"></i>Edit basic auth</button>' +
                '</div>' +
                '<div class="text-align-right"><button type="button" class="small switch-on float-right basic-auth-remove"></button></div>' +
            '</div>';
        } else {
            html +=
            '<button type="button" class="basic-auth-edit text-primary-small"><i class="fa-solid fa-circle-plus"></i>Add basic auth</button>';
        }

        this.$el.find('.region-basic-auth').html(html);
    },

    renderHttpHeader: function() {
        var html = '';

        if (this.model.get('http_header')) {
            html += '<div class="grid-5-7 grid-gap-8 margin-bottom-12">';
            html += '<div class="font-weight-medium">Key</div><div class="font-weight-medium">Value</div>';
            html += JSON.parse(this.model.get('http_header')).map((header) => {
                return '' +
                '<input type="text" class="solid compact" readonly value="' + Util.htmlEntities(header.key) + '">' +
                '<input type="text" class="solid compact" readonly value="' + Util.htmlEntities(header.value) + '">';
            }).join('');
            html += '</div>';

            html += '<button type="button" class="http-headers-edit text-primary-small"><i class="fa-solid fa-circle-plus"></i>Edit header</button>';
        } else {
            html += '<button type="button" class="http-headers-edit text-primary-small"><i class="fa-solid fa-circle-plus"></i>Add header</button>';
        }

        this.$el.find('.region-http-header').html(html);
    },

    render: function() {
        var content =
        '<div class="project-settings-inner-large form-fluid">' +
            '<div class="field-label">Basic authentication <a class="info tooltip" href="https://support.userback.io/en/articles/5209239-configure-your-project-settings" data-title="Learn more" target="help" rel="noopener"><i class="fad fa-xs fa-question-circle"></i></a></div>' +
            '<p>When your website requires basic authentication, you will need to whitelist our servers. Userback\'s rendering engine needs access to your site\'s static resources (images + stylesheets) to accurately render your screens.</p>' +
            '<div class="region-basic-auth box-small-medium"></div>' +
            '<div class="divider-24"></div>' +
            '<div class="field-label">HTTP headers <a class="info tooltip" href="https://support.userback.io/en/articles/5209187" data-title="Learn more" target="help" rel="noopener"><i class="fad fa-xs fa-question-circle"></i></a></div>' +
            '<p>When your site is in a protected environment, you can add extra HTTP headers in order to identify requests made from our screenshot servers and whitelist them accordingly.</p>' +
            '<div class="region-http-header box-small-medium"></div>' +
        '</div>';

        this.$el.html(content);

        this.renderBasicAuth();
        this.renderHttpHeader();

        return this;
    }
});